import { getAttackArrowHeadPoints, getAttackArrowBodyPoints } from './attack_arrow'
import * as plotUtil from '../plot_util'

const HALF_PI = Math.PI / 2

const squadCombatOpts = {
    tailWidthFactor: 0.1
}

const getSquadCombatTailPoints = function (points) {
    let allLen = plotUtil.getBaseLength(points);
    let tailWidth = allLen * squadCombatOpts.tailWidthFactor;
    let tailLeft = plotUtil.getThirdPoint(points[1], points[0], HALF_PI, tailWidth, false);
    let tailRight = plotUtil.getThirdPoint(points[1], points[0], HALF_PI, tailWidth, true);
    return [tailLeft, tailRight];
};

export default function (coordinates) {
    if (coordinates.length < 2) return []
    let tailPnts = getSquadCombatTailPoints(coordinates);
    let headPnts = getAttackArrowHeadPoints(coordinates, tailPnts[0], tailPnts[1]);
    let neckLeft = headPnts[0];
    let neckRight = headPnts[4];
    let bodyPnts = getAttackArrowBodyPoints(coordinates, neckLeft, neckRight, squadCombatOpts.tailWidthFactor);
    let count = bodyPnts.length;
    let leftPnts = [tailPnts[0]].concat(bodyPnts.slice(0, count / 2));
    leftPnts.push(neckLeft);
    let rightPnts = [tailPnts[1]].concat(bodyPnts.slice(count / 2, count));
    rightPnts.push(neckRight);

    leftPnts = plotUtil.getQBSplinePoints(leftPnts);
    rightPnts = plotUtil.getQBSplinePoints(rightPnts);

    return [leftPnts.concat(headPnts, rightPnts.reverse())];
}